import { trackMetric } from './Telemetry.js'

/**
 * Authentication / onboarding funnel. These fire around login/registration, mostly BEFORE the org
 * is loaded, so they usually carry no org bundle — that's intentional (lets us see organic signups
 * vs. existing-customer flows).
 *
 * `login_redirect` vs `login_failed` is the distinction that matters and the one we originally got
 * wrong: visiting the app while unauthenticated makes `LoginEpic` bounce the visitor to Keycloak,
 * which used to be recorded as `login_failed`. That is the *normal* path, and counting it as a
 * failure put a permanent ~50% "auth failure rate" on every dashboard. Only `login_failed` is a
 * tripwire; real credential failures happen inside Keycloak and are not visible to us at all.
 */
export type AuthStage =
  | 'registration_submit'
  | 'registration_success'
  | 'registration_failed'
  | 'login_success'
  /** No session yet — the visitor was sent to Keycloak to sign in. Expected, not an error. */
  | 'login_redirect'
  /** The session lookup came back but was unusable (e.g. no email on the profile). */
  | 'login_failed'
  | 'invitation_accepted'

export const trackAuth = (stage: AuthStage, extra: Record<string, string | number | boolean> = {}): void => {
  trackMetric('auth.action', { stage, ...extra })
}
